import {
  ReviewedDocumentation,
  GeneralDocumentationData,
  ProcedureInternalId,
  BatchInternalId,
  MadeiristaId
} from '@/Domain/ReviewedDocumentation'
import { ReviewedDocumentationRepository } from '@/Domain/ReviewedDocumentation/ReviewedDocumentationRepository'
import { ProcedureId } from '@/Domain/Procedures'
import { AccountId } from '@/Domain/Account'
import {
  FileInfo,
  DocumentId,
  FileName,
  RejectionReason,
  FileInfoStatus,
  FileInfoType
} from '@/Domain/ReviewedDocumentation/FileInfo'

const createReviewedDocumantation = () => {
  const fileInfoOne = new FileInfo(
    new DocumentId(331),
    new FileName('Conexion_VPN_Fortinet_v3.pdf'),
    new RejectionReason('-'),
    FileInfoStatus.PENDIENTE_REVISION,
    FileInfoType.SOLVENCIA_ECONOMICA
  )
  const fileInfoTwo = new FileInfo(
    new DocumentId(425),
    new FileName('Otro archiov.pdf'),
    new RejectionReason('-'),
    FileInfoStatus.APTO,
    FileInfoType.SOLVENCIA_TECNICA
  )
  const fileInfoThree = new FileInfo(
    new DocumentId(123),
    new FileName('Un tercer archivo.pdf'),
    new RejectionReason('-'),
    FileInfoStatus.EN_REQUERIMENTO,
    FileInfoType.PODER_BASTANTE
  )
  const generalDocumentationData = new GeneralDocumentationData(
    new ProcedureId('OU-PX-2020-12'),
    new ProcedureInternalId(87),
    new BatchInternalId(216),
    new MadeiristaId(903)
  )
  return (
    new ReviewedDocumentation(
      generalDocumentationData,
      [fileInfoOne, fileInfoTwo, fileInfoThree]
    )
  )
}

async function wait (ms: number) {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}

export class InMemoryReviewedDocumentationRepository implements ReviewedDocumentationRepository {
  // eslint-disable-next-line
  async byProcedureAndAccountId (procedureCode: ProcedureId, accountId: AccountId): Promise<ReviewedDocumentation> {
    const duration = 300
    await wait(duration)
    const reviews = createReviewedDocumantation()
    return reviews
  }
}
